var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"greetings-message white--text text-body-1 text-center text-md-h5",attrs:{"data-testid":"greetings-message"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }